import MetricItemSchema from '../schemas/MetricItemSchema'

export default function MetricItemVo(initData = {}) {
  return MetricItemSchema.validateSync(initData)
}
